import { Grid } from '@simplywallst/ui-core';

import { Narrative } from '@/pages/Narrative/hooks/useNarrative';
import NarrativeVoting from '@/pages/Narrative/components/NarrativeVoting';
import { CreateAnnouncement } from '@/pages/Narrative/components/CreateAnnouncement';
import { FollowNarrative } from '@/pages/Narrative/components/FollowNarrative';
import { EditNarrative } from '@/pages/Narrative/components/EditNarrative';
import { ReportNarrative } from '@/pages/Narrative/components/ReportNarrative';

type Props = {
  narrative: Narrative;
};

export const NarrativeActions = ({ narrative }: Props) => {
  const { author, id, slug, voteCount } = narrative;
  return (
    <Grid
      gap="8px"
      autoFlow="column"
      autoColumns="max-content"
      width="100%"
      justifyContent="end"
    >
      <ReportNarrative narrativeId={narrative.id} slug={narrative.slug} />
      <NarrativeVoting
        narrativeId={id}
        slug={slug}
        upVotes={voteCount.upvotes}
      />
      <EditNarrative id={id} authorId={author.id} />
      <CreateAnnouncement id={id} slug={slug} />
      <FollowNarrative narrative={narrative} />
    </Grid>
  );
};
